import styled from "styled-components";
import { Icon } from "@evergis/ui";

export const ImageAttributesContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const ImagePreview = styled.img`
  display: flex;
  height: 4.5rem;
  width: 4.5rem;
  margin-top: 0.5rem;
  cursor: pointer;
  margin-right: 0.5rem;
  border-radius: ${({ theme: { borderRadius } }) => borderRadius.smallest};
  object-fit: cover;
`;

export const ImageMask = styled.div`
  position: absolute;
  margin-top: 0.5rem;
  margin-left: 2.5rem;
  visibility: hidden;

  ${Icon} {
    color: white;
  }
`;

export const ImageWrapper = styled.div`
  &:hover {
    filter: brightness(0.65);

    ${ImageMask} {
      visibility: visible;
    }
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  height: 4.5rem;
  width: 4.5rem;
  margin-top: 0.5rem;
  cursor: pointer;
  border-radius: ${({ theme: { borderRadius } }) => borderRadius.smallest};
  background-color: rgba(0, 0, 0, 0.06);
  align-items: center;
  justify-content: center;
`;
